import {useServices} from "../../../../react-hooks/use-services.hook"
import {ClientSettingsContentContainerBox} from "./boxes/content-container/client-settings-content-container.box";

export const ClientSettingsContentComponent = () => {
    const services = useServices();
    const availableSections = services.clientSettings.sections;

    return (
        <ClientSettingsContentContainerBox>
            {availableSections.map(section => section.render())}
        </ClientSettingsContentContainerBox>
    )
}